export const WORKSPACE_STORAGE_KEY = 'signalfly.workspace.v1';

export function normalizeExchange(exchange) {
  return String(exchange || '').trim().toUpperCase();
}

export function normalizeMarketType(marketType) {
  return String(marketType || '').trim().toUpperCase();
}

export function resolveWorkspace(scope = {}) {
  return {
    exchange: normalizeExchange(scope.exchange),
    marketType: normalizeMarketType(scope.marketType),
  };
}

export function getStoredWorkspace() {
  try {
    const raw = localStorage.getItem(WORKSPACE_STORAGE_KEY);
    if (!raw) {
      return resolveWorkspace();
    }

    return resolveWorkspace(JSON.parse(raw));
  } catch (error) {
    return resolveWorkspace();
  }
}

export function persistWorkspace(scope) {
  const workspace = resolveWorkspace(scope);
  localStorage.setItem(WORKSPACE_STORAGE_KEY, JSON.stringify(workspace));
  return workspace;
}

export function resolveWorkspaceFromRoute(params = {}) {
  return resolveWorkspace({
    exchange: params.exchange,
    marketType: params.marketType,
  });
}

export function buildScopedApiParams(scope, params = {}) {
  const workspace = resolveWorkspace(scope);
  const searchParams = new URLSearchParams();

  searchParams.set('exchange', workspace.exchange);
  searchParams.set('marketType', workspace.marketType);

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') {
      return;
    }

    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item !== undefined && item !== null && item !== '') {
          searchParams.append(key, item);
        }
      });
      return;
    }

    searchParams.set(key, value);
  });

  return searchParams;
}

export function buildScopedPath(basePath, scope, suffix = '') {
  const workspace = resolveWorkspace(scope);
  const normalizedBase = basePath.endsWith('/') ? basePath.slice(0, -1) : basePath;
  const normalizedSuffix = suffix ? (suffix.startsWith('/') ? suffix : `/${suffix}`) : '';
  return `${normalizedBase}/${workspace.exchange}/${workspace.marketType}${normalizedSuffix}`;
}

export function getWorkspaceLabel(scope) {
  const workspace = resolveWorkspace(scope);
  return `${workspace.exchange} / ${workspace.marketType}`;
}
